import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';
@Component({
  selector: 'lc-super-shop-page',
  templateUrl: './super-shop-page.component.html',
  styleUrls: ['./super-shop-page.component.scss']
})
export class SuperShopPageComponent implements OnInit {
  public super_user_id: string;
  constructor(public dataService: DataService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params =>{
      this.super_user_id = params['pid'];
      this.dataService.remarks_by = this.super_user_id;
    })
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/super-shop-page/super-shop-page.component.ts